/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import PaymentProviderCaptureMethod from 'DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Empty/Method/Content",
  method,
  person
  
}) {
  return (<React.Fragment
>
<PaymentProviderCaptureMethod
  viewPath={`${viewPath}/PaymentProviderCaptureMethod`}
 method={method}
 person={person}
/>
{children}
</React.Fragment>)
}